"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EventAllocationType;
(function (EventAllocationType) {
    EventAllocationType["team"] = "team";
    EventAllocationType["homeOnly"] = "homeOnly";
    EventAllocationType["competition"] = "competition";
    EventAllocationType["usePercentage"] = "usePercentage";
})(EventAllocationType = exports.EventAllocationType || (exports.EventAllocationType = {}));
//# sourceMappingURL=EventAllocationType.js.map